import {Component, OnInit} from '@angular/core';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {moduloGaritas} from '../../diccionarios/balanzaModulo.js';
import {UtilsService} from 'src/app/shared/utils/utils.service';
import {Subscription} from "rxjs";
import {
  LfsaBotonEditarGridComponent
} from 'src/app/shared/components/lfsa-boton-editar-grid/lfsa-boton-editar-grid.component';
import {UsuarioBasculaGaritaService} from '../../services/usuario-bascula-garita.service';
import {MantenimientoBasculaService} from '../../services/mantenimiento-bascula.service';
import {MantenimientoGaritasService} from '../../services/mantenimiento-garitas.service';
import {IGaritaResponse} from '../../modelos/IMantGarita';
import {IMantBascula} from '../../modelos/IMantBascula';
import {UsuariosService} from '../../services/usuarios.service';
import {IUsuarioAll} from '../../modelos/IUsuario.js';
import {ParametrizarValorFleteService} from '../../services/parametrizar-valor-flete.service';
import {
  ParametrizacionesDeFactoresConversionService
} from '../../services/parametrizaciones-de-factores-conversion.service';
import { ProveedorService } from '../../services/proveedor.service';

@Component({
  selector: 'app-parametrizaciones-de-factores-conversion',
  templateUrl: './parametrizaciones-de-factores-conversion.component.html',
  styleUrls: ['./parametrizaciones-de-factores-conversion.component.css']

})
export class ParametrizacionesDeFactoresConversionComponent implements OnInit {

  public DAT_TITULOS: any = moduloGaritas.titulos.parametrizacionesDeFactoresConversion;
  public DAT_BTNS: any = moduloGaritas.button.buttonsNombre;
  public DAT_BTNCSS: any = moduloGaritas.button.buttonsCss;
  public DAT_AG_GRID: any = moduloGaritas.agGrid;
  public DAT_MSG: any = moduloGaritas.mensajes;

  public gridApi: any;
  public gridColumnApi: any;
  public frameworkComponents: any;
  public columnDefs: any[] = [];
  public rowData: any[] = [];
  public garitaSelect: IGaritaResponse[] = [];
  public basculaSelect: IMantBascula[] = [];

  public isCreate: boolean = false;
  public tituloModal: string = '';
  public loading: boolean = false;
  public showUsers: boolean = false;
  public proveedorInvalido = true;

  public agregarForm = new FormGroup({
    id: new FormControl(null),
    proveedor: new FormControl(null, []),
    signo: new FormControl(null, [Validators.required]),
    rangoIni: new FormControl(null, [Validators.required, Validators.pattern(/^\d+$/)]),
    rangoFin: new FormControl('', [Validators.required, Validators.pattern(/^\d+$/)]),
    incremento: new FormControl('', [Validators.required, Validators.pattern(/^(?!0\d|$)\d*(\.\d{1,8})?$/)]),
    despro: new FormControl('', []),
  });
  public cmbUsuarios: IUsuarioAll[] = [];
  proveedor = "";
  validSameRecord = false;
  private subscription = new Subscription();

  constructor(
    private _util: UtilsService,
    private usuarioBasculaGaritaS: UsuarioBasculaGaritaService,
    private basculaService: MantenimientoBasculaService,
    private garitasService: MantenimientoGaritasService,
    private usuariosService: UsuariosService,
    private proveedorS: ProveedorService,
    private parametrizarValorFleteService: ParametrizarValorFleteService,
    private ParametrizacionesDeFactoresConversionService: ParametrizacionesDeFactoresConversionService
  ) {
  }

  get proveeControl() {
    return this.agregarForm.get('proveedor');
  }

  ngOnInit() {
    this.girdComponent();
    this.obtenerTodo();
  }

  girdComponent() {
    this.frameworkComponents = {
      buttonRenderer: LfsaBotonEditarGridComponent,
    };

    this.columnDefs = [
      {
        headerName: 'Id',
        field: 'id',
        sortable: true,
        filter: true,
        width: 100,
      },
      {
        headerName: 'Proveedor',
        field: 'proveedor',
        sortable: true,
        filter: true
      },
      {
        headerName: 'Signo',
        field: 'signo',
        sortable: true,
        filter: true,
      },
      {
        headerName: 'Rango Inicial',
        field: 'rangoIni',
        sortable: true,
        filter: true,
      },
      {
        headerName: 'Rango Final',
        field: 'rangoFin',
        sortable: true,
        filter: true,
      },
      {
        headerName: '',
        cellRenderer: 'buttonRenderer',
        width: 80,
        cellRendererParams: {
          onClick: this.editar.bind(this),
          label: this.DAT_BTNS.editar,
          colorBoton: this.DAT_BTNCSS.info,
        },
      },
      {
        headerName: '',
        cellRenderer: 'buttonRenderer',
        width: 80,
        cellRendererParams: {
          onClick: this.eliminar.bind(this),
          label: this.DAT_BTNS.eliminar,
          colorBoton: this.DAT_BTNCSS.danger,
        },
      }
    ];
  }

  obtenerTodo() {
    this.loading = true;
    this.subscription.add(
      this.ParametrizacionesDeFactoresConversionService.obtener().subscribe(
        (resp) => {
          this.rowData = resp;
          this.loading = false;
        },
        (error) => {
          this.rowData = [];
          this.loading = false;
        }
      )
    );
  }

  guardarCrearNueva() {
    this.loading = true;
    if (this.agregarForm.invalid) return;
    let data = this.agregarForm.getRawValue();
    //proveedor 0 aplica para todos
    data.proveedor = data.proveedor == null ? 0: data.proveedor.trim();

    this._util
      .confirmarSincronoPromesa({
        title: this.DAT_MSG.procesar,
        text: `Usuario: ${data.idusuario} ${data.bascula ? `- Báscula: ${data.bascula}` : ``} ${data.garita ? `- Garita: ${data.garita}` : ``}`,
        action: this.DAT_BTNS.nuevo,
        funcion: this.ParametrizacionesDeFactoresConversionService.crear(data),
      })
      .then(() => {
        this.obtenerTodo();
        this.loading = false;
        this.closeModal();
      })
      .catch(() => {
        this.loading = false;
      });
  }

  guardarEditar() {
    this.loading = true;
    if (this.agregarForm.invalid) return;
    let data = this.agregarForm.getRawValue();

    this._util
      .confirmarSincronoPromesa({
        title: this.DAT_MSG.actualizar,
        text: `Usuario: ${data.idusuario} ${data.bascula ? `- Báscula: ${data.bascula}` : ``} ${data.garita ? `- Garita: ${data.garita}` : ``}`,
        action: this.DAT_BTNS.editar,
        funcion: this.ParametrizacionesDeFactoresConversionService.editar(data),
      })
      .then(() => {
        this.obtenerTodo();
        this.loading = false;
        this.closeModal();
      })
      .catch(() => {
        this.loading = false;
      });
  }

  eliminar({rowData}) {
    this.loading = true;
    this._util
      .confirmarSincronoPromesa({
        title: this.DAT_MSG.eliminar,
        text: `Usuario: ${rowData.idusuario} ${rowData.bascula ? `- Báscula: ${rowData.bascula}` : ``} ${rowData.garita ? `- Garita: ${rowData.garita}` : ``}`,
        action: this.DAT_BTNS.eliminar,
        funcion: this.ParametrizacionesDeFactoresConversionService.eliminar(rowData.id),
      })
      .then((res: any) => {
        this.obtenerTodo();
        this.loading = false;
      })
      .catch((error) => {
        this.loading = false;
      });
  }

  nuevo() {
    this.isCreate = true;
    this.tituloModal = this.DAT_TITULOS.tituloAgregar;
    this.agregarForm.reset();
    this.agregarForm.get('id').disable({onlySelf: true});
    this.openModal();
  }

  editar({rowData}) {
    this.isCreate = false;
    this.tituloModal = this.DAT_TITULOS.tituloActualizar;
    this.agregarForm.patchValue(rowData);
    this.agregarForm.get("id").disable();
    this.openModal();
  }

  onGridReady(params) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
    params.api.sizeColumnsToFit();
  }

  acciones(event) {
    if (event === 'regresar') return this.closeModal();
    if (this.isCreate) this.guardarCrearNueva();
    if (!this.isCreate) this.guardarEditar();
  }

  openModal() {
    document.getElementById('abrirModal').click();
  }

  closeModal() {
    document.getElementById('cerrarModal').click();
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  getDescProveedor(proveedor: string): any {
    console.log("proveedor", proveedor)
    let prov = "";
    if (this.proveeControl.value > 0) {
      this.parametrizarValorFleteService.getProveedor(proveedor).subscribe(
        (resp) => {
          if (resp) prov = resp.provNombre;
          prov = '';
        },
        (error) => {
          prov = '';
        }
      );
      return prov;
    }
  }

  onChangeProveedor(event: any) {
    console.log("onChangeProveedor", this.proveeControl.value)
    if (event.key == " " || event.code == "Space" || event.keyCode == 32) return;
    this.loading = true;
    if (this.proveeControl.value != null && this.proveeControl.value.length > 0) {
      this.proveedorS.obtenerPorId(this.proveeControl.value.trim()).subscribe(
        (resp) => {
          if (resp) {
            this.proveedorInvalido = false;
            this.agregarForm.controls['despro'].setValue(resp.idProveedor + " - " + resp.nombre);
          } else {
            this.proveedorInvalido = true;
            this.agregarForm.controls['despro'].setValue('');
          }
          this.onChangeValues();
          this.loading = false;
        },
        (error) => {
          this.onChangeValues();
          this.loading = false;
          this.proveedorInvalido = true;
          this.agregarForm.controls['despro'].setValue('');
        }
      );
    }
  }

  noWhitespace(event: KeyboardEvent) {
    if (event.key == " " || event.code == "Space" || event.keyCode == 32)
      return false;

    return true;
  }

  onChangeValues() {
    this.validSameRecord = false;
    let signo = this.agregarForm.get("signo").value;
    let rangoIni = this.agregarForm.get("rangoIni").value;
    let rangoFin = this.agregarForm.get("rangoFin").value;
    let proveedor = this.agregarForm.get("proveedor").value;

    console.log("signo", signo)
    console.log("rangoIni", rangoIni)
    console.log("rangoFin", rangoFin)

    for (let i = 0; i < this.rowData.length; i++) {
      if(this.rowData[i].id == this.agregarForm.get("id")) continue;
      if (
        signo == this.rowData[i].signo &&
        this.rowData[i].rangoIni == rangoIni &&
        this.rowData[i].proveedor == proveedor
      ) {
        this.validSameRecord = true;
        break;
      }
    }

  }

  validForm() {
    return (
      this.agregarForm.invalid == false &&
      this.validSameRecord == false) ? false : true;
  }

}
